export default "__VITE_ASSET___BzhlWag__"